import {Routes} from '@angular/router';
import {CampaignResolver} from "../common/presentation/resolver/campaign.resolver";

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('../pages/home-page/home-page.component')
  },
  {
    path: 'campaign/:slug',
    redirectTo: ({params}) => {
      if ('slug' in params) {
        // @ts-ignore
        return `/campaigns/${params.slug}`;
      }
      return '/';
    }
  },
  {
    path: 'about',
    loadComponent: () => import('../pages/about-page/about-page.component')
  },
  {
    path: 'donate',
    loadComponent: () => import('../pages/donate-page/donate-page.component')
  },
  {
    path: 'donate-car',
    loadComponent: () => import('../pages/donate-car-page/donate-car-page.component')
  },
  {
    path: 'contact',
    loadComponent: () => import('../pages/contact-page/contact-page.component')
  },
  {
    path: 'faq',
    loadComponent: () => import('../pages/faq-page/faq-page.component')
  },
  {
    path: 'thankyou',
    loadComponent: () => import('../pages/thank-you-page/thank-you-page.component')
  },
  {
    path: 'languages',
    loadComponent: () => import('../pages/languages-page/languages.page')
  },
  {
    path: 'sitemap',
    loadComponent: () => import('../pages/sitemap-page/sitemap.page')
  },
  {
    path: 'campaigns',
    loadComponent: () => import('../pages/campaigns-page/campaigns-page')
  },
  {
    path: 'campaigns/:slug',
    resolve: {
      campaign: CampaignResolver
    },
    loadComponent: () => import('../pages/campaigns-page/[slug]/campaign-page').then(m => m.CampaignPage)
  },
  // {
  // 	path: '**',
  // 	redirectTo: '',
  // },
  // {
  // 	path: '',
  // 	redirectTo: '',
  // 	pathMatch: 'full'
  // }
];
